import VariableSelection from '@/bo/VariableSelection';

export default {
    selectedYears: [],
    selectedLocations: [],
    selectedLocation: -1,
    currentStep: 'years',
    v: {
        dependent: VariableSelection.newNotIncluded(),
        independent: []
    }
}
